import createReducer from 'arts/config/create_reducer';
import Constants from 'arts/config/constants';

const mailSubscription = createReducer({ allow: window.allowNLetter }, {
  [Constants.MailSubscriptions.DISALLOW]: () => ({ allow: false })
});

export default mailSubscription;
